import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import namesListDialogTemplate from '../../templates/NamesListDialog.template.html';

export default angular
  .module('entitiesAdmin.dialogs.NamesListDialog', [CSMCommonWeb])
  .service('NamesListDialog', Service)
  .name;

/*******************************************************************************
 * Service: NamesListDialog
 *
 * Dialog to print lists of entities.
 *******************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Show the modal dialog for printing entities.
   *
   * @param  hideFamily   Removes the family option from the list.
   * @param  hideMembers  Removes the members option from the list.
   * @param  minGrade     Minimun grade available. Null=use default
   * @param  maxGrade     Maximum grade available. Null=use default.
   *
   * @return              Promise that resolves when the modal dialog is closed.
   ****************************************************************************/
  this.show = function (hideFamily, hideMembers, minGrade, maxGrade) {
    /*--------------------------------------------------------*/
    /* Validate min and max grades. Use default values if     */
    /* values are invalid, or maxGrade is less than minGrade. */
    /*--------------------------------------------------------*/
    var min =
      angular.isNumber(minGrade) && Number(minGrade) >= 0
        ? Number(minGrade)
        : 0;
    var max =
      angular.isNumber(maxGrade) && Number(maxGrade) <= 15
        ? Number(maxGrade)
        : 15;

    if (Number(max) < Number(min)) {
      min = 0;
      max = 15;
    }

    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: NamesListDialogController,
      resolve: {
        hideFamily: function () {
          return hideFamily;
        },
        hideMembers: function () {
          return hideMembers;
        },
        minGrade: function () {
          return min;
        },
        maxGrade: function () {
          return max;
        }
      },
      size: 'md',
      template: namesListDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */
var NamesListDialogController = function (
  $scope,
  Session,
  hideFamily,
  hideMembers,
  maxGrade,
  minGrade,
  SERVER
) {
  /***************************************************************************
   * Properties
   ***************************************************************************/
  /** Is BoosterFinance/PTA Org Flag. */ var isBoosterPTA =
    SERVER.productID != 'ASB Works';
  /** Constant list of grades. */ $scope.gradeList = [];
  /** Current grade selection. */ $scope.selectedGrade = null;
  /** Current print type.      */ $scope.selectedPrint = null;
  /** Fiscal year. */ var fiscalYear = NaN;

  /** All Members Print Object */
  var allMembers = { name: 'ASB Card Holder List', listType: 'm', value: 0 };

  /** Family Members Print Object */
  var familyMembers = {
    name: 'Family',
    listType: 'n',
    value: SERVER.BooksDBConstants.ET_FAMILY
  };

  /** List of options for the print list. */
  $scope.dpPrint = [
    { name: 'All Names', listType: 'n', value: 0 },
    {
      name: 'Students',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_STUDENT
    },
    {
      name: 'Teachers',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_TEACHER
    },
    {
      name: 'Parents',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_PARENT
    },
    {
      name: 'Grandparents',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_GRANDPARENT
    },
    {
      name: 'Community Partner',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_COMMUNITY_PARTNER
    },
    familyMembers,
    {
      name: 'Other Names',
      listType: 'n',
      value: SERVER.BooksDBConstants.ET_OTHER
    },
    allMembers
  ];

  /*-----------------------------------*/
  /* Grandparent and Community Partner */
  /* types are only available to PTA.  */
  /*-----------------------------------*/
  if (!SERVER.currentUser.orgType.startsWith('PTA')) {
    $scope.dpPrint.removeItem(
      $scope.dpPrint.find(function (element) {
        return element.value == SERVER.BooksDBConstants.ET_GRANDPARENT;
      })
    );
    $scope.dpPrint.removeItem(
      $scope.dpPrint.find(function (element) {
        return element.value == SERVER.BooksDBConstants.ET_COMMUNITY_PARTNER;
      })
    );
  }

  /***************************************************************************
   * generateList */
  /**
   * Checks inputs and generates report
   ***************************************************************************/
  $scope.generateList = function () {
    var pageURL =
      (isBoosterPTA ? '/PTANamesList.aspx' : 'NamesList.aspx') +
      '?lt=' +
      $scope.selectedPrint.listType +
      '&rt=' +
      $scope.reportFormat +
      '&etfy=' +
      ($scope.showFY()
        ? ($scope.numFY() || 0).toString()
        : $scope.selectedPrint.value) +
      '&gd=' +
      ($scope.selectedGrade.value < 0 ? '' : $scope.selectedGrade.value) +
      '&ao=' +
      $scope.chkActiveOnly.toString();
    window.open(Session.getSessionURL(pageURL));
  };

  /***************************************************************************
   * init */
  /**
   * Set up the dataprovider based on the flags passed in to the dialog.
   * items.
   ***************************************************************************/
  function init() {
    /*---------------------------*/
    /* Populate the grades list. */
    /*---------------------------*/
    for (var i = maxGrade; i >= minGrade; i--)
      $scope.gradeList.push({ label: i.toString(), value: i });
    $scope.gradeList.unshift({ label: 'All', value: -1 });

    /*-----------------------------------------------*/
    /* Set the label for the membership print option */
    /*-----------------------------------------------*/
    allMembers.name = isBoosterPTA ? 'PTA Members' : 'ASB Card Holders';

    /*-------------------------------------------------*/
    /* Remove the member option if it is to be hidden. */
    /*-------------------------------------------------*/
    if (hideMembers)
      $scope.dpPrint = $scope.dpPrint.filter(function (o) {
        return o != allMembers;
      });

    /*-------------------------------------------------*/
    /* Remove the family option if it is to be hidden. */
    /*-------------------------------------------------*/
    if (hideFamily)
      $scope.dpPrint = $scope.dpPrint.filter(function (o) {
        return o != familyMembers;
      });

    /*----------------------------------*/
    /* Preselect default dialog values. */
    /*----------------------------------*/
    $scope.selectedGrade = $scope.gradeList[0];
    $scope.selectedPrint = $scope.dpPrint[0];
    $scope.chkActiveOnly = true;
    $scope.reportFormat = 'PDF';
  }

  /***************************************************************************
   * numFY */
  /**
   * Getter setter for Fiscal Year input. Saves user input and returns NaN if
   * the input is not a number.
   *
   * @param   val      User input
   *
   * @return  Integer  Fiscal year to print with.
   ***************************************************************************/
  $scope.numFY = function (val) {
    /** Getter */
    if (!arguments.length)
      return angular.isNumber(fiscalYear) ? fiscalYear : NaN;

    /** Setter */
    fiscalYear = val;
  };

  /***************************************************************************
   * showFY */
  /**
   * Returns an indication to show/hide the fiscal year input.
   *
   * @return  Boolean  True=show input field.
   ***************************************************************************/
  $scope.showFY = function () {
    return $scope.selectedPrint.listType == 'm';
  };

  /***************************************************************************
   * showGrade */
  /**
   * Returns an indication to show/hide the grade selection.
   *
   * @return  Boolean  True=show selection.
   ***************************************************************************/
  $scope.showGrade = function () {
    return (
      ($scope.selectedPrint.value == 0 &&
        $scope.selectedPrint.listType == 'n') ||
      $scope.selectedPrint.value == SERVER.BooksDBConstants.ET_STUDENT
    );
  };

  /*--------------------------*/
  /* Set up the modal dialog. */
  /*--------------------------*/
  init();
};
